import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "animate.css";
import WOW from "wowjs";
import Image from "../images/mt_everest.jpg";
import "../App.css"; // Ensure to include your custom CSS here

const About = () => {
  useEffect(() => {
    new WOW.WOW({ live: false }).init();
  }, []);

  return (
    <section className="about-section py-5">
      <Container>
        <Row className="align-items-center">
          {/* Title */}
          <h2 className="text-center mb-4" style={{ fontSize: "40px" }}>
            The Story of Finding the Path to the Base of Everest
          </h2>

          {/* Text Section */}
          <Col
            md={6}
            className="wow animate__animated animate__fadeInLeft"
            data-wow-duration="1.5s"
          >
            <p className="text-muted" style={{ lineHeight: "1.8em" }}>
              In 1865, Mount Everest was officially declared the tallest peak in the world, sparking global fascination. At the time, two superpowers dominated the world: Russia and the British Empire. Between their territories lay the Karakoram and Himalayan mountain ranges. To the north, Nepal and Tibet had closed their borders to the British. Recognizing the strategic importance of the region, the British decided they at least needed detailed maps of these areas.
              <br />
              
             
            </p>
            <a
              href={`${process.env.PUBLIC_URL}/The-story-of-finding-path.pdf`}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
              style={{ width: "250px" }}
            >
              Read More
            </a>
          
          </Col>

          {/* Image Section */}
          <Col
            md={6}
            className="position-relative wow animate__animated animate__fadeInRight"
            data-wow-duration="1.5s"
          >
            <div className="image-wrapper position-relative">
              <img
                src={Image}
                alt="About Us"
                className="img-fluid rounded shadow"
                style={{
                  border: "2px solid ",
                  padding: "5px",
                  marginTop: "10px",
                }}
              />
              <div
                className="overlay-box position-absolute"
                style={{
                  bottom: "20px",
                  left: "20px",
                  backgroundColor: "#fff",
                  padding: "10px 20px",
                  borderRadius: "5px",
                  boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.3)",
                }}
              >
                {/* <span className="text-dark">
                  <strong>5 Years</strong> <br /> Experience Working
                </span> */}
              </div>
            </div>
          </Col>

          {/* Link to PDF */}
          <Col md={12} className="text-center mt-3">
           
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default About;
